import { Button as MuiButton } from "@material-ui/core";
import React, { FunctionComponent } from "react";

import style from "./button.module.scss";

interface IButton {
  isActive?: boolean;
  label?: string;
  isLoading?: boolean;
  buttonStyle?: React.CSSProperties;
  startIcon?: any;
  variant?: "text" | "outlined" | "contained";
  onClick?: () => void;
}

export const Button: FunctionComponent<IButton> = ({
  isActive = true,
  onClick = () => {},
  label = "Submit",
  isLoading = false,
  buttonStyle = {},
  variant = "contained",
  // tslint:disable-next-line:trailing-comma
  ...props
}) => {

  return (<div style={buttonStyle} className={style["wrapper"]}>
      <MuiButton
        onClick={onClick}
        fullWidth
        disabled={!isActive}
        variant={variant}
        color="primary"
        {...props}
      >
        {label}
      </MuiButton>
    </div>);
};
